import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form-row rd-gap-x-4 phone-container" }
const _hoisted_2 = ["id", "placeholder", "aria-describedby", "aria-required", "aria-invalid"]
const _hoisted_3 = {
  key: 0,
  class: "rd-w-full rd-mt-2 rd-relative"
}
const _hoisted_4 = { class: "form-element-wrapper" }
const _hoisted_5 = {
  class: "rd-font-normal rd-mb-0 rd-ml-2.5 rd-mt-px",
  for: "smsOptIn"
}

import { inject, Ref, computed } from "vue";
import { useRenderStore } from "@/builder/stores/renderStore";
import { vMaska } from "maska/vue";
import ValidatedInput from "@/builder/components/input/ValidatedInput.vue";
import { PageDesign } from "../page/PageInterface";
import { FieldStyle } from "@/builder/enums";


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneNumberInputComponent',
  props: ["component"],
  setup(__props) {


const store = useRenderStore();

const pageDesign = inject("pageDesign") as Ref<PageDesign>;
const fieldStyle = computed(() => {
    return pageDesign.value.fieldStyle;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ValidatedInput, {
      id: __props.component.id,
      value: _unref(store).donor.phone,
      label: __props.component.customData.label,
      name: "Donor.Phone",
      class: _normalizeClass(["rd-w-full", { 'form-compact-full': fieldStyle.value == _unref(FieldStyle).Compact }]),
      isRequired: __props.component.customData.required
    }, {
      input: _withCtx((inputProps) => [
        _withDirectives(_createElementVNode("input", {
          type: "tel",
          id: __props.component.id + '_Donor.Phone',
          placeholder: __props.component.customData.placeholder,
          "aria-describedby": inputProps.describedBy,
          "aria-required": inputProps.required,
          "aria-invalid": inputProps.isInvalid,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).donor.phone) = $event)),
          "data-maska": "(###) ###-####",
          autocomplete: "tel"
        }, null, 8, _hoisted_2), [
          [_vModelText, _unref(store).donor.phone],
          [_unref(vMaska)]
        ])
      ]),
      extraContent: _withCtx(() => [
        (__props.component.customData.showOptIn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  id: "smsOptIn",
                  type: "checkbox",
                  class: "rd-relative",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(store).donor.phoneOptIn) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _unref(store).donor.phoneOptIn]
                ]),
                _createElementVNode("label", _hoisted_5, _toDisplayString(__props.component.customData.optInLabel), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["id", "value", "label", "class", "isRequired"])
  ]))
}
}

})